import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';

const HeaderContainer = styled.header`
  background-color: var(--royal-blue);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  border-bottom: 2px solid var(--gold);
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 50px;
    margin-right: 1rem;
  }

  h1 {
    font-family: 'Blackwood Castle', serif;
    font-size: 2rem;
    color: var(--gold);
    font-weight: 300;
    position: relative;
    overflow: hidden;
    background: linear-gradient(
      90deg,
      var(--gold) 0%,
      #fffbe6 40%,
      var(--gold) 60%,
      var(--gold) 100%
    );
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
    animation: shine var(--shine-duration) linear infinite;

  }
`;

const NavLinks = styled.nav`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: ${({ isOpen }) => (isOpen ? '0' : '-100%')};
    width: 70%;
    height: 100vh;
    background-color: var(--royal-blue);
    flex-direction: column;
    justify-content: center;
    transition: right 0.3s ease-in-out;
    border-left: 2px solid var(--gold);
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.5);
  }
`;

const NavAnchor = styled.a`
  margin: 0 1rem;
  font-family: 'Blackwood Castle', serif;
  font-size: 1.2rem;
  color: var(--white);
  position: relative;
  transition: color 0.3s ease;
  text-decoration: none;

  &:hover {
    color: var(--gold);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: var(--gold);
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }

  @media (max-width: 768px) {
    margin: 1rem 0;
    font-size: 1.5rem;
  }
`;

const MobileMenuToggle = styled.div`
  display: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--gold);
  z-index: 1001;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <HeaderContainer style={{ backgroundColor: `var(--royal-blue)` }}>
      <Logo>
        <img src="/images/logolys.png" alt="Love Your Skin" />
        <h1>Love Your Skin</h1>
      </Logo>

      <MobileMenuToggle onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </MobileMenuToggle>

      <NavLinks isOpen={isOpen}>
        <NavAnchor href="#home" onClick={() => setIsOpen(false)}>Accueil</NavAnchor>
        <NavAnchor href="#artistes" onClick={() => setIsOpen(false)}>Artistes</NavAnchor>
        <NavAnchor href="#tarifs" onClick={() => setIsOpen(false)}>Tarifs & Horaires</NavAnchor>
        <NavAnchor href="#soins" onClick={() => setIsOpen(false)}>Soins & Conseils</NavAnchor>
        <NavAnchor href="#contact" onClick={() => setIsOpen(false)}>Nous Trouver</NavAnchor>
      </NavLinks>
    </HeaderContainer>
  );
};

// Ajout du scroll fluide pour toute la page
if (typeof window !== 'undefined') {
  document.documentElement.style.scrollBehavior = 'smooth';
}

export default Header;
